// src/utils/storage.ts
var localStorageUtils = {
  get(key) {
    if (typeof window === "undefined") return null;
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch {
      console.error(`Error reading localStorage key "${key}"`);
      return null;
    }
  },
  set(key, value) {
    if (typeof window === "undefined") return;
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      console.error(`Error setting localStorage key "${key}"`);
    }
  },
  remove(key) {
    if (typeof window === "undefined") return;
    try {
      localStorage.removeItem(key);
    } catch {
      console.error(`Error removing localStorage key "${key}"`);
    }
  },
  clear() {
    if (typeof window === "undefined") return;
    try {
      localStorage.clear();
    } catch {
      console.error("Error clearing localStorage");
    }
  }
};
var isBrowser = typeof window !== "undefined";
var isNative = isBrowser && window.location.protocol === "capacitor:";
var isPWA = isBrowser && (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true);

// src/utils/format.ts
function formatDate(date, locale = "de-DE", options) {
  const d = typeof date === "number" ? new Date(date * 1e3) : new Date(date);
  return d.toLocaleDateString(locale, options);
}
function formatTime(date, locale = "de-DE", options) {
  const d = typeof date === "number" ? new Date(date * 1e3) : new Date(date);
  return d.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    ...options
  });
}
function formatDateTime(date, locale = "de-DE") {
  const d = typeof date === "number" ? new Date(date * 1e3) : new Date(date);
  return d.toLocaleString(locale, {
    dateStyle: "short",
    timeStyle: "short"
  });
}
function formatRelativeTime(date, locale = "de-DE") {
  const d = typeof date === "number" ? new Date(date * 1e3) : new Date(date);
  const now = /* @__PURE__ */ new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffSec = Math.round(diffMs / 1e3);
  const diffMin = Math.round(diffSec / 60);
  const diffHour = Math.round(diffMin / 60);
  const diffDay = Math.round(diffHour / 24);
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  if (Math.abs(diffSec) < 60) {
    return rtf.format(-diffSec, "second");
  } else if (Math.abs(diffMin) < 60) {
    return rtf.format(-diffMin, "minute");
  } else if (Math.abs(diffHour) < 24) {
    return rtf.format(-diffHour, "hour");
  } else {
    return rtf.format(-diffDay, "day");
  }
}
function formatWeight(kg, unit = "kg") {
  if (unit === "lb") {
    const lb = kg * 2.20462;
    return `${lb.toFixed(1)} lb`;
  }
  return `${kg.toFixed(1)} kg`;
}
function truncate(text, maxLength) {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength - 3) + "...";
}

// src/utils/id.ts
function generateId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}
function generateShortId() {
  return generateId().split("-")[0];
}
function isValidUUID(id) {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
}

export { formatDate, formatDateTime, formatRelativeTime, formatTime, formatWeight, generateId, generateShortId, isBrowser, isNative, isPWA, isValidUUID, localStorageUtils, truncate };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map